import React from "react";
import { Form, Col, ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import RATooltip from "../RATooltip";

export default function AverageTypePicker({ formData, setFormData, name }) {
    return (
        <Form.Group as={Col} className="d-flex flex-column col-12 col-xl-auto">
            <Form.Label>
                Average
                <RATooltip className="ms-1">
                    <p>
                        <strong>13 weeks </strong>- Avg. of latest 13 weeks from the selected timeframe, holidays and corrupted days are excluded.
                    </p>
                    <p>
                        <strong>Last year</strong> - The same weekday in the same calendar week of the previous year, in the HEALTH module, corrupted days are
                        excluded
                    </p>
                </RATooltip>
            </Form.Label>
            <ToggleButtonGroup
                type={"radio"}
                name="average"
                value={formData.lastYearAverages ?? false}
                onChange={value => setFormData({ ...formData, lastYearAverages: value })}
                className="ra-switcher">
                <ToggleButton id={`${name}-average-normal`} className=" text-nowrap" variant={"ra-dark-blue-outline"} value={false}>
                    13 Weeks
                </ToggleButton>
                <ToggleButton id={`${name}-average-last-year`} className=" text-nowrap" variant={"ra-dark-blue-outline"} value={true}>
                    Last Year
                </ToggleButton>
            </ToggleButtonGroup>
        </Form.Group>
    );
}
